import React, {useEffect} from 'react'
// import ScrollAnim from 'rc-scroll-anim'

// import {useDispatch, useSelector} from 'react-redux'
// import {RootState} from 'store'
import styled from 'styled-components'
// import ShanShui from '../../assets/images/OurStory_ShanShui.png'
// import ShanShuiTop from '../../assets/images/OurStory_Top_Sm.png'
import GlobalPhenomenonTitle from '../../assets/images/GlobalPhenomenonTitle.svg'
import Breakpoint from '../../utils/breakpoint'
import Font from '../../utils/Font'
import {Box} from './styles'

const {mobile, desk} = Breakpoint
const mdBreakpoint = 1000
const chineseLang = ['zh-tw', 'zh-cn']
const otherLangsMap = [...chineseLang, 'ja']

interface ContainerProps {
  readonly langCode: string
}
const Container = styled.div<ContainerProps>`
  font-family: ${({langCode}) => Font(langCode).mainFont};
  background-color: #fcfaf7;
  @media (max-width: ${mobile}px) {
  }
  @media (min-width: 1200px) {
  }
`

const WrapperContent = styled.div<ContainerProps>`
  max-width: ${({langCode}) => (otherLangsMap.indexOf(langCode) > -1 ? '600' : '720')}px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 8rem;
  padding-top: 2.8rem;
  padding-bottom: 4.8rem;
  @media (max-width: ${mobile}px) {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
  }
  @media (min-width: ${desk}px) and (max-width: ${mdBreakpoint}px) {
    //max-width: 40vw;
  }
`
const MainContentText = styled.div``
const Label = styled.h2<ContainerProps>`
  padding-top: 3rem;
  padding-bottom: 2.5rem;
  color: #633b1a;
  text-align: ${({langCode}) => (langCode === 'il' ? 'right' : 'left')};
`
interface IProps {
  miscData: any
  langCode: string
  translation: any
  // onClick(event: React.MouseEvent<HTMLButtonElement>): void
  // ...
}

const GlobalPhenomenon: React.FC<IProps> = ({miscData, translation, langCode}) => {
  const isChineseLang = chineseLang.indexOf(langCode) > -1
  return (
    <>
      <Container className="a-left" langCode={langCode}>
        <WrapperContent langCode={langCode}>
          {isChineseLang ? (
            <Label langCode={langCode}>
              <Box>
                <img src={GlobalPhenomenonTitle} />
              </Box>
            </Label>
          ) : (
            <Label langCode={langCode} className="MainHeading">
              {translation['A Global Phenomenon']}
            </Label>
          )}

          <MainContentText className="Paragraph" dangerouslySetInnerHTML={{__html: miscData['GlobalPhenomenon']}} />
        </WrapperContent>
      </Container>
    </>
  )
}

// GlobalPhenomenon.propTypes = {
//   miscData: PropTypes.object,
//   translation: PropTypes.object,
//   langCode: PropTypes.string,
// }

export default GlobalPhenomenon
